<div class="dirurbana_conteiner-form editar_conteiner">
    <form [formGroup]="empresaForm">
        <!-- opciones para la direccion urbana -->

        <div formGroupName="direccion">
            <div *ngIf="datosCargados">
                <h2 class="dirurbana_title">Editar dirección</h2>
                <label for="departamento">
                    Departamento:
                    <sup class="text-danger">*</sup>
                </label>
                <select
                    formControlName="departamento"
                    class="dirurbana_conteiner-enable"
                    (change)="getMunicipio()">
                    <option [ngValue]="null" [selected]="true">
                        Seleccione un departamento
                    </option>
                    <option
                        *ngFor="let departament of departamentos"
                        [ngValue]="departament.id">
                        {{ departament.nombre }}
                    </option>
                </select>
                <div
                    *ngIf="
                        empresaForm
                            ?.get('direccion.departamento')
                            ?.hasError('required') &&
                        empresaForm?.get('direccion.departamento')?.touched
                    ">
                    <p class="error-message">El departamento es obligatorio.</p>
                </div>
                <br />
                <br />
            </div>
            <div>
                <label for="municipioId">
                    Municipio
                    <sup class="text-danger">*</sup>
                </label>
                <select
                    formControlName="municipioId"
                    class="dirurbana_conteiner-enable">
                    <option [ngValue]="null" [selected]="null">
                        Seleccione un municipio
                    </option>
                    <option
                        *ngFor="let municiopio of municipios"
                        [ngValue]="municiopio.id">
                        {{ municiopio.nombre }}
                    </option>
                </select>
            </div>

            <div
                *ngIf="
                    empresaForm
                        .get('direccion.municipioId')
                        .hasError('required') &&
                    empresaForm.get('direccion.municipioId').touched
                ">
                <p class="error-message">El municipio es obligatorio.</p>
            </div>

            <div>
                <label for="zona">
                    Zona
                    <sup class="text-danger">*</sup>
                </label>
                <select
                    formControlName="zona"
                    class="dirurbana_conteiner-enable">
                    <option [ngValue]="null" [selected]="true">
                        Seleccione una zona
                    </option>
                    <option value="Rural">Rural</option>
                    <option value="Urbana">Urbana</option>
                </select>
            </div>

            <div
                *ngIf="
                    empresaForm.get('direccion.zona').hasError('required') &&
                    empresaForm.get('direccion.zona').touched
                ">
                <p class="error-message">La zona es obligatorio.</p>
            </div>

            <div *ngIf="empresaForm.get('direccion.zona').value === 'Rural'">
                <!-- Direccion -->

                <div class="form-cpntrol">
                    <label for="complemento">
                        Dirección rural
                        <sup class="text-danger">*</sup>
                    </label>
                    <input
                        type="text"
                        id="complemento"
                        formControlName="complemento"
                        class="dirurbana_conteiner-enable" />
                    <div
                        *ngIf="
                            empresaForm.get('direccion.complemento').invalid &&
                            empresaForm.get('direccion.complemento').touched
                        "
                        class="error-message">
                        Direccion rural es requerida
                    </div>
                </div>
            </div>

            <div
                *ngIf="empresaForm.get('direccion.zona').value === 'Urbana'"
                class="dirurbana_conteinr-colums">
                <!-- Tipo de vía principal -->
                <div class="dirurbana_conteinr-colum">
                    <div class="form-cpntrol">
                        <label
                            for="viaPrincipalTipo"
                            class="ellipsis-container">
                            Vía Principal
                            <sup class="text-danger">*</sup>
                        </label>

                        <div class="explicacion" id="explicacion">
                            Tipo de vía principal
                            <sup class="text-danger">*</sup>
                        </div>

                        <select formControlName="viaPrincipalTipo">
                            <option value="Anillo vial">Anillo vial</option>
                            <option value="Avenida">Avenida</option>
                            <option value="Avenida calle">Avenida calle</option>
                            <option value="Avenida carrera">
                                Avenida carrera
                            </option>
                            <option value="Calle">Calle</option>
                            <option value="Carrera">Carrera</option>
                            <option value="Circunvalar">Circunvalar</option>
                            <option value="Diagonal">Diagonal</option>
                            <option value="Transversal">Transversal</option>
                        </select>
                    </div>

                    <!-- Cuadrante de Vía Principal -->
                    <div class="form-cpntrol">
                        <label
                            for="viaPrincipalCuadrante"
                            class="ellipsis-container">
                            Cuadrante de Vía Principal
                        </label>
                        <div class="explicacion" id="explicacion">
                            Cuadrante de Vía Principal
                        </div>
                        <select formControlName="viaPrincipalCuadrante">
                            <option [ngValue]="null"></option>
                            <option value="Norte">Norte</option>
                            <option value="Sur">Sur</option>
                            <option value="Este">Este</option>
                            <option value="Oeste">Oeste</option>
                        </select>
                    </div>
                </div>

                <div class="dirurbana_conteinr-colum">
                    <!-- Numero de vía principal -->
                    <div class="form-cpntrol">
                        <label
                            for="viaPrincipalNumero"
                            class="ellipsis-container">
                            Número de Vía Principal
                            <sup class="text-danger">*</sup>
                        </label>
                        <div class="explicacion" id="explicacion">
                            Número vía principal
                            <sup class="text-danger">*</sup>
                        </div>

                        <input
                            type="number"
                            id="viaPrincipalNumero"
                            formControlName="viaPrincipalNumero" />
                    </div>

                    <!-- Numero de Vía Generadora -->
                    <div class="form-cpntrol">
                        <label
                            for="viaGeneradoraNumero"
                            class="ellipsis-container">
                            N. Vía Secundario
                            <sup class="text-danger">*</sup>
                        </label>
                        <div class="explicacion" id="explicacion">
                            Numero Vía Secundario
                            <sup class="text-danger">*</sup>
                        </div>
                        <input
                            type="number"
                            id="viaGeneradoraNumero"
                            formControlName="viaGeneradoraNumero" />
                    </div>
                </div>
                <div class="dirurbana_conteinr-colum">
                    <!-- Letra de Vía Principal -->
                    <div>
                        <label
                            for="viaPrincipalLetra"
                            class="ellipsis-container">
                            Letra inicial tipo de vía principal
                        </label>
                        <div class="explicacion" id="explicacion">
                            Letra inicial tipo de vía principal
                        </div>
                        <select formControlName="viaPrincipalLetra">
                            <option value=""></option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                            <option value="E">E</option>
                            <option value="F">F</option>
                            <option value="G">G</option>
                            <option value="H">H</option>
                            <option value="I">I</option>
                            <option value="J">J</option>
                            <option value="K">K</option>
                            <option value="L">L</option>
                            <option value="M">M</option>
                            <option value="N">N</option>
                            <option value="O">O</option>
                            <option value="P">P</option>
                            <option value="Q">Q</option>
                            <option value="R">R</option>
                            <option value="S">S</option>
                            <option value="T">T</option>
                            <option value="U">U</option>
                            <option value="V">V</option>
                            <option value="W">W</option>
                            <option value="X">X</option>
                            <option value="Y">Y</option>
                            <option value="Z">Z</option>
                        </select>
                    </div>

                    <!-- Letra de Vía Generadora -->
                    <div class="form-cpntrol">
                        <label
                            for="viaGeneradoraLetra"
                            class="ellipsis-container">
                            Letra tipo de vía secundario
                        </label>
                        <div class="explicacion" id="explicacion">
                            Letra tipo de vía secundario
                        </div>
                        <select formControlName="viaGeneradoraLetra">
                            <option value=""></option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                            <option value="E">E</option>
                            <option value="F">F</option>
                            <option value="G">G</option>
                            <option value="H">H</option>
                            <option value="I">I</option>
                            <option value="J">J</option>
                            <option value="K">K</option>
                            <option value="L">L</option>
                            <option value="M">M</option>
                            <option value="N">N</option>
                            <option value="O">O</option>
                            <option value="P">P</option>
                            <option value="Q">Q</option>
                            <option value="R">R</option>
                            <option value="S">S</option>
                            <option value="T">T</option>
                            <option value="U">U</option>
                            <option value="V">V</option>
                            <option value="W">W</option>
                            <option value="X">X</option>
                            <option value="Y">Y</option>
                            <option value="Z">Z</option>
                        </select>
                    </div>
                </div>

                <div class="dirurbana_conteinr-colum">
                    <!-- Prefijo Bis -->
                    <div class="form-cpntrol dirurbana_bis">
                        <label for="prefijoBis" class="ellipsis-container">
                            Prefijo Bis
                        </label>
                        <div class="explicacion" id="explicacion">
                            Prefijo Bis
                        </div>
                        <input
                            type="checkbox"
                            id="prefijoBis"
                            formControlName="prefijoBis" />
                    </div>
                    <!-- Numero de Placa -->
                    <div class="form-cpntrol">
                        <label for="numeroPlaca" class="ellipsis-container">
                            Número complemento
                            <sup class="text-danger">*</sup>
                        </label>
                        <div class="explicacion" id="explicacion">
                            Número complemento
                            <sup class="text-danger">*</sup>
                        </div>
                        <input
                            type="number"
                            id="numeroPlaca"
                            formControlName="numeroPlaca" />
                    </div>
                </div>

                <div class="dirurbana_conteinr-colum">
                    <!-- Letra del Prefijo -->
                    <div class="form-cpntrol">
                        <label for="letraPrefijo" class="ellipsis-container">
                            Letra complementaria tipo de vía principal
                        </label>
                        <div class="explicacion" id="explicacion">
                            Letra complementaria tipo de vía principal
                        </div>
                        <select formControlName="letraPrefijo">
                            <option value=""></option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                        </select>
                    </div>
                    <!-- Cuadrante de Vía Generadora -->
                    <div class="form-cpntrol">
                        <label
                            for="viaGeneradoraCuadrante"
                            class="ellipsis-container">
                            Cuadrante de Vía Secundaria
                        </label>
                        <div class="explicacion" id="explicacion">
                            Cuadrante de Vía Secundaria
                        </div>
                        <select formControlName="viaGeneradoraCuadrante">
                            <option [ngValue]="null"></option>
                            <option value="Norte">Norte</option>
                            <option value="Sur">Sur</option>
                            <option value="Este">Este</option>
                            <option value="Oeste">Oeste</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="empresaForm.get('direccion.zona').value === 'Urbana'">
            <input
                placeholder="dirección"
                class="dirurbana_visualizar"
                type="text"
                readonly
                [value]="direccionActualView"
                [disabled]="true" />
            <!-- mensajes de errores -->
            <div *ngFor="let campo of camposDirecciones">
                <div
                    *ngIf="esInvalidoYtocado(campo.nombre)"
                    class="error-message">
                    {{ campo.mensaje }}
                </div>
            </div>
        </div>
        <div>
            <button
                type="submit"
                class="styles_btn-accept"
                (click)="submitEditar()">
                Guardar
            </button>
        </div>
    </form>
</div>
